import type { DashboardContext } from 'tio-employee/utils/partner-dashboard/registry';

/**
 * Wraps a loader so every widget and attention source on one dashboard visit
 * shares a single request. The cache is keyed by the visit's context object,
 * so the next visit (a new context) fetches fresh data.
 */
export function oncePerVisit<T>(load: (ctx: DashboardContext) => Promise<T>) {
  const cache = new WeakMap<DashboardContext, Promise<T>>();
  return (ctx: DashboardContext) => {
    let pending = cache.get(ctx);
    if (!pending) {
      pending = load(ctx);
      cache.set(ctx, pending);
    }
    return pending;
  };
}
